module.exports = __webpack_public_path__ + "static/media/melissa11.904f5d42.jpg";